package br.com.vvrefeicoes.portal.feature.purchases

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.Icon
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.AppTextField
import br.com.vvrefeicoes.portal.domain.model.MonthPeriod
import br.com.vvrefeicoes.portal.domain.model.PurchasesExtraDirectorate
import br.com.vvrefeicoes.portal.domain.model.PurchasesPanelCategory
import br.com.vvrefeicoes.portal.domain.model.PurchasesPanelProductDetail
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.Search
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.compras_search_placeholder

internal val PURCHASES_TABLE_LARGE_WIDTH = 1600.dp
internal val PURCHASES_TABLE_MEDIUM_WIDTH = 1000.dp
internal const val NO_TABLE_VALUE = "\u2014"

internal fun monthsPerTable(maxWidth: Dp): Int =
    when {
        maxWidth >= PURCHASES_TABLE_LARGE_WIDTH -> 6
        maxWidth >= PURCHASES_TABLE_MEDIUM_WIDTH -> 4
        else -> 2
    }

internal fun activePurchaseMonths(
    categories: List<PurchasesPanelCategory>,
    months: List<MonthPeriod>,
): List<MonthPeriod> =
    months.filter { month ->
        categories.any { category ->
            category.monthly.any { it.year == month.year && it.month == month.month && it.totalCents > 0L }
        }
    }

internal fun categoryActiveMonths(category: PurchasesPanelCategory): List<MonthPeriod> =
    category.monthly
        .filter { it.totalCents > 0L }
        .map { MonthPeriod(it.year, it.month) }

internal fun extraActiveMonths(
    directorates: List<PurchasesExtraDirectorate>,
    months: List<MonthPeriod>,
): List<MonthPeriod> =
    months.filter { month ->
        directorates.any { directorate ->
            directorate.months.any {
                it.year == month.year &&
                    it.month == month.month &&
                    it.orderCount > 0L
            }
        }
    }

internal fun filterProductDetails(
    details: List<PurchasesPanelProductDetail>,
    query: String,
): List<PurchasesPanelProductDetail> {
    val normalized = query.trim()
    return details
        .filter { normalized.isEmpty() || it.productName.contains(normalized, ignoreCase = true) }
        .sortedBy { it.productName.lowercase() }
}

@Composable
internal fun ProductDetailsSearch(
    query: String,
    onQueryChange: (String) -> Unit,
) {
    AppTextField(
        value = query,
        onValueChange = onQueryChange,
        placeholder = stringResource(Res.string.compras_search_placeholder),
        leadingIcon = { Icon(Lucide.Search, contentDescription = null) },
        modifier = Modifier.fillMaxWidth(),
    )
}
